import GoogleReviews from './GoogleReviews.vue'

export default GoogleReviews
